import { render } from "./Index.vue?vue&type=template&id=3e0becc1"
const script = {}

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__